import { useCatalogProductListData } from '@apps/registry/common/components/Catalog/hooks/useCatalogProductListData/useCatalogProductListData';
import { CATALOG_PRODUCT_LIST_PAGE_SIZE } from '@apps/registry/common/components/Catalog/Catalog.constants';
import { BrandPageProps } from '@apps/registry/common/components/Catalog/routes/BrandPage/BrandPage';
import { useGetBrandDetails } from '@apps/registry/common/components/Catalog/api/queries/getBrandDetails';
import { deriveTelemetryPage, useCatalogContext } from '@apps/registry/common/components/Catalog';
import { useState } from 'react';
import { useShopStorefrontContext } from '../../components/ShopStorefrontProvider';
import { useTranslation } from '@shared/core';

export const useBrandPageController = (props: BrandPageProps) => {
  const { brandLocator } = props;
  const { currentStorefront } = useShopStorefrontContext();
  const { t } = useTranslation('catalogRegistry');
  const seoTrans = t('seo', currentStorefront);

  const [isMobileDescriptionExpanded, setIsMobileDescriptionExpanded] = useState<boolean>(false);

  const { addCatalogItemToRegistry, addCatalogItemLoading } = useCatalogContext();

  const { brandDetails, loading: brandDetailsLoading, error: brandDetailsError } = useGetBrandDetails({ brandPublicUrl: `/shop/brand/${brandLocator}` });

  const { productList, loading, error: productsError, isFetchingMore, handleOnLoadMoreProductsButtonClick, hasNextPage, filters } = useCatalogProductListData({
    pageSize: CATALOG_PRODUCT_LIST_PAGE_SIZE,
    selectedCategory: null,
    searchTerm: null,
    telemetryPageValue: 'brandPage'
  });

  const telemetryPageValue = deriveTelemetryPage({
    defaultValue: 'brandPage',
    view: 'productGrid',
    product: null,
    selectedCategory: null
  });

  return {
    seoTrans,
    brandDetails,
    brandDetailsLoading,
    brandDetailsError,
    products: productList,
    productsLoading: loading,
    productsError,
    isFetchingMore,
    telemetryPageValue,
    addCatalogItemToRegistry,
    addCatalogItemLoading,
    handleOnLoadMoreClick: handleOnLoadMoreProductsButtonClick,
    hasNextPage,
    filters,
    isMobileDescriptionExpanded,
    setIsMobileDescriptionExpanded
  };
};
